import CryptoJS from "crypto-js";

/**
 * Şifreyi hash'ler
 * @param {string} password - Hash'lenecek şifre
 * @param {string} salt - Opsiyonel salt, belirtilmezse rastgele oluşturulur
 * @returns {Object} { hash, salt } - Hash'lenmiş şifre ve kullanılan salt
 */
export const hashPassword = (password, salt = null) => {
  // Eğer salt belirtilmemişse rastgele bir salt oluştur
  if (!salt) {
    salt = CryptoJS.lib.WordArray.random(128 / 8).toString();
  }
  // PBKDF2 ile şifreyi hash'le (daha güvenli için 100,000 iterasyon)
  const hash = CryptoJS.PBKDF2(password, salt, {
    keySize: 256 / 32,
    iterations: 100000,
  }).toString();
  return { hash, salt };
};

/**
 * Girilen şifrenin veritabanındaki hash ile eşleşip eşleşmediğini kontrol eder
 * @param {string} password - Kontrol edilecek şifre
 * @param {string} hash - Veritabanındaki hash'lenmiş şifre
 * @param {string} salt - Veritabanındaki salt
 * @returns {boolean} - Şifrelerin eşleşip eşleşmediği
 */
export const verifyPassword = (password, hash, salt) => {
  // Girilen şifreyi veritabanındaki salt ile hash'le
  const { hash: computedHash } = hashPassword(password, salt);
  // Oluşturulan hash ile veritabanındaki hash'i karşılaştır
  return computedHash === hash;
};

/**
 * Güçlü bir rastgele şifre oluşturur
 * @param {number} length - Şifre uzunluğu (varsayılan: 12)
 * @returns {string} - Oluşturulan rastgele şifre
 */
export const generateRandomPassword = (length = 12) => {
  const charset =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
  let password = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    password += charset[randomIndex];
  }
  return password;
};

/**
 * Şifre gücünü kontrol eder
 * @param {string} password - Kontrol edilecek şifre
 * @returns {Object} - { isValid: boolean, message: string }
 */
export const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  if (password.length < minLength) {
    return {
      isValid: false,
      message: "Şifre en az 8 karakter olmalıdır.",
    };
  }
  if (!hasUpperCase) {
    return {
      isValid: false,
      message: "Şifre en az bir büyük harf içermelidir.",
    };
  }
  if (!hasLowerCase) {
    return {
      isValid: false,
      message: "Şifre en az bir küçük harf içermelidir.",
    };
  }
  if (!hasNumbers) {
    return {
      isValid: false,
      message: "Şifre en az bir rakam içermelidir.",
    };
  }
  if (!hasSpecialChar) {
    return {
      isValid: false,
      message: "Şifre en az bir özel karakter içermelidir.",
    };
  }
  return { isValid: true, message: "Şifre güçlü." };
};
